import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FinalCTA() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleJoinWaitlist = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('final-cta');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-gradient-to-b from-[#0a0a0c] to-[#09090b]">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center space-y-6 sm:space-y-8 lg:space-y-10 transition-all duration-700 ${
            animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h2 className="text-white text-[28px] sm:text-[36px] lg:text-[48px] font-black leading-tight">
            This Is What You've Been Waiting For
          </h2>

          <p className="text-[#d4d4d8] text-base sm:text-lg lg:text-xl leading-relaxed max-w-[700px] mx-auto">
            AI that drafts your pleadings. From your phone. In seconds. Without compromising privilege
          </p>

          <p className="text-white text-base sm:text-lg lg:text-xl font-bold">
            Founder spots are limited. Pre-Launch pricing ends at launch
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-4">
            <button
              onClick={handleJoinWaitlist}
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-[#d4af37] text-black text-sm sm:text-base lg:text-lg font-bold rounded-full hover:shadow-[0_0_40px_rgba(212,175,55,0.6)] transition-all cursor-pointer whitespace-nowrap"
            >
              Claim Founder Spot — $25/mo
            </button>
            <button
              onClick={handleJoinWaitlist}
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-[#06b6d4] text-white text-sm sm:text-base lg:text-lg font-bold rounded-full hover:shadow-[0_0_40px_rgba(6,182,212,0.4)] transition-all cursor-pointer whitespace-nowrap"
            >
              Join Pre-Launch — $79/mo
            </button>
          </div>

          <p className="text-[#a1a1aa] text-xs sm:text-sm lg:text-base flex items-center justify-center gap-2">
            <span className="text-base sm:text-lg">🔒</span>
            14-day refund guarantee. No questions asked
          </p>
        </div>
      </div>
    </section>
  );
}
